import React from 'react'
import TipsTricksCard from '../components/TipsTricksCard'

function TipsTricks() {
    return (
        <div className="Tips-Tricks-Container">
            <h1>TipsTricks</h1>
            <div className="row">

            <TipsTricksCard />
            <TipsTricksCard />
            <TipsTricksCard />
            <TipsTricksCard />
            </div>
        </div>
    )
}

export default TipsTricks
